<mat-card class="rounded-2xl border border-gray-6 shadow-sm h-full overflow-hidden">
  <mat-card-header class="bg-gray-1 py-4 px-6 border-b border-gray-6 flex flex-row items-center w-full">
    <div class="flex items-center gap-3">
      <div class="flex h-10 w-10 items-center justify-center rounded-xl bg-indigo-3 text-indigo-11">
        <mat-icon class="text-indigo-11!">handshake</mat-icon>
      </div>
      <div>
        <mat-card-title class="text-lg! font-bold! m-0! text-gray-12!"
          >Règles & Conditions de mandat</mat-card-title
        >
      </div>
    </div>
    @if (editable()) {
      <div class="ml-auto flex items-center gap-2">
        <button
          mat-icon-button
          class="text-indigo-11 bg-indigo-a3 hover:bg-indigo-a4 transition-colors rounded-full"
          (click)="editMode() ? onCancel() : onEdit()"
        >
          <mat-icon>{{ editMode() ? 'close' : 'edit' }}</mat-icon>
        </button>
      </div>
    }
  </mat-card-header>
  <mat-card-content class="p-6">
    @if (!editMode()) {
      <etxe-property-mandate-display
        [mandate]="property().mandate"
        [sellingPriceCents]="property().financials?.sellingPriceCents"
      ></etxe-property-mandate-display>
    } @else {
      <div class="bg-gray-2 p-6">
        <etxe-property-mandate-form
          [dto]="property().mandate"
          [sellingPriceCents]="property().financials?.sellingPriceCents"
          (validityChanged)="onValidityChanged($event)"
          (dtoChanged)="onDtoChanged($event)"
        ></etxe-property-mandate-form>
        <div class="flex justify-end gap-3 mt-6 border-t border-gray-6 pt-4">
          <button mat-button (click)="onCancel()">Annuler</button>
          <button
            mat-flat-button
            class="primary"
            [disabled]="saving() || !isFormValid()"
            (click)="onSubmit()"
          >
            Enregistrer
          </button>
        </div>
      </div>
    }
  </mat-card-content>
</mat-card>
